<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
				<FormItem label="姓名" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入名称"  maxlength="12"></Input>
				</FormItem>
				<FormItem label="联系方式" prop="phone" class="sj">
					<Input v-model="formValidate.phone" placeholder="请输入联系方式" maxlength="11"></Input>
				</FormItem>
				<FormItem label="家庭住址" prop="address" class="sj">
					<Input v-model="formValidate.address" placeholder="请输入家庭住址"  maxlength="30"></Input>
				</FormItem>
				<FormItem label="登陆账号" class="sj">
					<Input v-model="formValidate.username" disabled="disabled"  maxlength="11"></Input>
				</FormItem>
				<FormItem label="状态" prop="state" class="sj">
					<Select v-model="formValidate.state" placeholder="请选择状态">
						<Option value="true">启用</Option>
						<Option value="false">禁用</Option>
					</Select>
				</FormItem>
				<FormItem label="片区" class="sj">
					<Input v-model="formValidate.districtName" disabled="disabled"></Input>
				</FormItem>
				<FormItem label="重选片区" prop="districtId" class="sj">
					<Cascader :data="data4" :load-data="loadData" :change-on-select="true" :not-found-text="kong" @on-change="onChange" @on></Cascader>
					
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	let _this
	export default {
		data() {
			return {
				loading:false, 
				query:{
					page:0,
					size:100,
					parentId:null
				},
				
				//级联属性
				data4:[],
				kong:'暂无下级',
				//级联属性
				formValidate: {
					id:'',
					name: '',
					phone: '',
					address: '',
					state: 'true',
					districtId:''
				},
				ruleValidate: {
					// districtId: [{
					// 	required: true,
					// 	message: '请选择片区！！！',
					// 	trigger: 'blur'
					// }],
					name: [{
						required: true,
						message: '姓名不能为空！！！',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '联系方式不能为空！！！',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '家庭住址不能为空！！！',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			onChange(a){
				console.log(a)
				this.formValidate.districtId=a[a.length-1]
				this.query.parentId=a[a.length-1]
				
			},
			loadData(item, callback){
				let _this=this
			    item.loading = true;
				_this.query.parentId=item.value
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/district/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let a1=0
						for (let i = 0; i < data.districts.content.length; i++) {
							let aa=data.districts.content[i]
							if(aa.isLower==true){
								let	a1={
										value: '',
										label: '',
										children: [],
										loading: false
								}
								a1.value=aa.id
								a1.label=aa.title
							    item.children.push(a1)
							}else{
								let	a1={
										value: '',
										label: ''
								}
								a1.value=aa.id
								a1.label=aa.title
							    item.children.push(a1)
							}
						}
						item.loading = false;
						callback();
						
					}
				  })
			},
			queryD(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/district/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						for (let i = 0; i < data.districts.content.length; i++) {
							let aa=data.districts.content[i]
							if(aa.isLower==true){
								let	a1={
										value: '',
										label: '',
										children: [],
										loading: false
								}
								a1.value=aa.id
								a1.label=aa.title
								_this.data4.push(a1)
							}else{
								let	a1={
										value: '',
										label: ''
								}
								a1.value=aa.id
								a1.label=aa.title
								_this.data4.push(a1)
							}
							
						}
					}
				  })
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				console.log(this.formValidate.districtId)
				this.$refs[name].validate((valid) => {
					if (valid) {
						
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/plat/oper/emp/update/ordinary',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		created() {
			let _this=this
			let id=this.$route.query.id
			this.formValidate.id=id
			
			_this.queryD()
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/plat/oper/emp/get',
			    data:{id:id},
				_this: _this,
				success: function(data) {
					_this.formValidate=data.emp
					_this.formValidate.state=data.emp.state+""
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/emp/update.vue